interface IMetaData {
    pageSlug: string;
    logoLink: string;
    pageDescription: string;
    pageTitle: string;
}

export const metaData = (props: IMetaData) => {
  const {
    logoLink = 'https://2k.sitisit.ru/_nuxt/img/header-logo.58d1bbe.svg?v=1680673009467',
    pageDescription = '',
    pageTitle = '',
    pageSlug,
  } = props;

  return [
    {
      hid: 'og:title',
      name: 'og:title',
      property: 'og:title',
      content: pageTitle || '',
    },
    {
      hid: 'og:site_name',
      name: 'og:site_name',
      property: 'og:site_name',
      content: '2000KOLES.RU',
    },
    {
      hid: 'og:description',
      name: 'og:description',
      property: 'og:description',
      content: pageDescription,
    },
    {
      hid: 'og:image',
      name: 'og:image',
      property: 'og:image',
      content: logoLink,
    },
    {
      hid: 'og:url',
      name: 'og:url',
      property: 'og:url',
      content: `https://2000koles.ru${pageSlug}`,
    },
  ];
};
